import { create } from "zustand";
import type { MeResponse } from "../api/client";

export interface AuthStoreState {
  me: MeResponse | null;
  loading: boolean;
  error: string | null;
  setMe: (me: MeResponse | null) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
}

export const useAuthStore = create<AuthStoreState>((set) => ({
  me: null,
  loading: false,
  error: null,
  setMe: (me) => set({ me }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
}));

